import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchInductionAttendanceByStudentIDCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/induction-attendance/fetch/studentid/coursecode`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchInductionAttendanceByStudentIDCourseCode: ${error.message}`));
            });
        },
        FetchInductionAttendancesByStudentID({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/induction-attendance/list/studentid`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data.payload);
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchInductionAttendancesByStudentID: ${error.message}`));
            });
        },
        UpsertInductionAttendance({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/induction-attendance/upsert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpsertInductionAttendance: ${error.message}`));
            });
        },
    },
}
